import { takeLatest, put, all, call } from "redux-saga/effects";
import { encryptData } from "../../_common/enode-decode";
import WebEnquiryTypes from "./webEnquiry.types";
import {
  webEnquiryExportChanged,
  webEnquiryExportFailure,
  webEnquiryExportSuccess,
  webEnquiryFetchFailure,
  webEnquiryFetchResponseChanged,
  webEnquiryFetchSuccess,
} from "./webEnquiry.action";
import { fetchWebEnquiry } from "./webEnquiry.service";
import { ComonExportPage } from "../../operation/attendance/attendance.service";

/** *********************** START WEB ENQUIRY FETCH ************************ */
export function* webEnquiryFetch({ payload }: any) {
  const key: any = "FetchEnquiryListJSONKey";
  try {
    const { FromDate, ToDate, Limit, CompanyID, EnquiryType, InstanceName } =
      payload;
    const jsonData: any = {
      FromDate: FromDate,
      ToDate: ToDate,
      Limit: Limit,
      CompanyID: CompanyID,
      EnquiryType: EnquiryType,
      InstanceName: InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchWebEnquiry, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(webEnquiryFetchFailure(responseData.data));
    } else {
      yield put(webEnquiryFetchSuccess(responseData.data));
    }
  } catch (error) {
    yield put(webEnquiryFetchFailure(error));
  }
}

export function* webEnquiryFetchReset() {
  yield put(webEnquiryFetchResponseChanged());
}

export function* onFetchWebEnquiry() {
  yield takeLatest(WebEnquiryTypes.WEB_ENQUIRY_FETCH_START, webEnquiryFetch);
}

export function* onWebEnquiryResponseReset() {
  yield takeLatest(
    WebEnquiryTypes.WEB_ENQUIRY_FETCH_RESET_START,
    webEnquiryFetchReset,
  );
}
/** *********************** END WEB ENQUIRY FETCH ************************ */

/** *********************** START WEB ENQUIRY EXPORT ************************ */
export function* webEnquiryExport({ payload }: any) {
  const key: any = "CreateRequestReportKey";
  try {
    const jsonData: any = {
      BranchID: payload.BranchID || "",
      IsFresh: payload.IsFresh || "1",
      ConditionExec: payload.ConditionExec || "",
      ExistRequestID: payload.ExistRequestID || 1,
      CreateDateTime:
        payload.CreateDateTime || new Date().toISOString().split("T")[0],
      RequestReportPage: payload.RequestReportPage || "WebEnquiryReport",
      CompanyID: payload.CompanyID,
      RequestedBy: payload.RequestedBy,
      URL: payload.URL || "",
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      MemberID: payload.MemberID,
      DateType: payload.DateType || "Y-m-d",
      InstanceName: payload.InstanceName,
      EnquiryType: payload.EnquiryType || "",
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(ComonExportPage, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(webEnquiryExportFailure(responseData.data));
    } else {
      yield put(webEnquiryExportSuccess(responseData.data));
    }
  } catch (error) {
    yield put(webEnquiryExportFailure(error));
  }
}

export function* webEnquiryExportReset() {
  yield put(webEnquiryExportChanged());
}

export function* onExportWebEnquiry() {
  yield takeLatest(WebEnquiryTypes.WEB_ENQUIRY_EXPORT_START, webEnquiryExport);
}

export function* onWebEnquiryExportReset() {
  yield takeLatest(
    WebEnquiryTypes.WEB_ENQUIRY_EXPORT_RESET_START,
    webEnquiryExportReset,
  );
}
/** *********************** END WEB ENQUIRY EXPORT ************************ */

/** *********************** END WEB ENQUIRY STATUS UPDATE ************************ */

export function* webEnquirySaga() {
  yield all([
    call(onWebEnquiryResponseReset),
    call(onFetchWebEnquiry),
    call(onExportWebEnquiry),
    call(onWebEnquiryExportReset),
  ]);
}
